import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getClients } from "../api";
import { DocListTab, SalesDocPage } from "./SalesDocShared";

export default function ReceiptsPage() {
  const { data: clients = [] } = useQuery({ queryKey: ["clients"], queryFn: getClients });

  return (
    <SalesDocPage
      title="Receipts"
      subtitle="Proof of payment. Generated from Tax Invoices and Billing Notes; void if issued in error."
      typeColor="#166534"
    >
      <DocListTab
        docType="receipt"
        clients={clients}
        readOnly
        allowVoid
      />
    </SalesDocPage>
  );
}
